import { Pagination as AntPagination } from "antd";
import clsx from "clsx";
import "./Pagination.scss";

export interface PaginationProps {
  total: number;
  onChange: ({ page, limit }: { page: number; limit: number }) => void;
  currentPage: number;
  defaultPageSize?: number;
  pageSize?: number;
  pageSizeOptions?: number[];
  showSizeChanger?: boolean;
  showQuickJumper?: boolean;
  autoScrollToTop?: boolean;
  className?: string;
  embedded?: boolean;
}

export const Pagination = ({
  total,
  onChange,
  currentPage,
  defaultPageSize = 50,
  pageSize,
  pageSizeOptions = [5, 8, 10, 15, 20],
  showSizeChanger = false,
  showQuickJumper = true,
  autoScrollToTop = true,
  className,
  embedded = false,
}: PaginationProps) => {
  const resolvedPageSize = pageSize ?? defaultPageSize;

  const handleChange = (page: number, limit: number) => {
    onChange({ page, limit });
    if (autoScrollToTop) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  };

  return (
    <AntPagination
      className={clsx(
        "app-pagination",
        embedded && "app-pagination-embedded",
        className,
      )}
      current={currentPage}
      pageSize={resolvedPageSize}
      total={total}
      showSizeChanger={showSizeChanger}
      pageSizeOptions={pageSizeOptions.map(String)}
      showQuickJumper={showQuickJumper}
      onChange={handleChange}
    />
  );
};
